import { Injectable } from '@angular/core'
import { SNACKBAR_CLASS } from '../../components/snackbar/model/snackbar.model'
import { SnackbarService } from '../../components/snackbar/service/snackbar.service'
import { I18nService } from '../../i18n/service/i18n.service'
import { SearchParams } from '../../model/searchParams'
import { HierarchyManagementService } from '../store-management/hierarchy-management/hierarchy-management.service'
import { Profile } from '../store-management/model/profile'
import { ProfileManagementService } from '../store-management/profile-management/profile-management.service'
import { BRAND_FAVICON } from 'src/app/authentication/model/auth.enum'
@Injectable({
	providedIn: 'root',
})
export class ApiSearchUtilService {
	basePath = window.location.hostname
	constructor(
		private hierarchyManagementService: HierarchyManagementService,
		private profileManagementService: ProfileManagementService,
		private snack: SnackbarService,
		private i18n: I18nService
	) {
	}

	getBaseSearchParams(): SearchParams {
		return {
			customerId: null,
			page: 1,
			pageSize: 10,
			searchGuid: '',
		}
	}

	getBaseSearchParamsTiresMovements(): SearchParams {
		return {
			customerId: null,
			page: 1,
			pageSize: 10,
			searchGuid: '',
			isMovimentazionePneus: true,
		}
	}

	addDynamicObjPostRestCall(domain, profile?): any {
		switch (domain) {
			case 'vehicles': {
				return this.getObjectScaffolding(
					'vehicles_detail',
					`/vehicle/detail-vehicle`
					// `/vehicle/detail-vehicle/${profile.plate}/${profile.contractId}/${profile.contractId}`
				)
			}
			case 'contracts': {
				return this.getObjectScaffolding('contracts_detail', `/contracts/detail`)
			}
			case 'tools_and_services': {
				if (profile.isFuelCard) {
					return this.getObjectScaffolding(
						'history-refuel',
						`/tools-service/history-refuel`
					)
				}
			}
			case 'maintenance_and_appointments': {
				return this.getObjectScaffolding(
					'contract_maintenances_list',
					`/maintenance-appointments/maintenance-detail`
				)
			}
			case 'management': {
				return this.getObjectScaffolding(
					'management_list',
					`/maintenance-appointments/maintenance-detail` //path nuovo component gestionale
				)
			}
		}
	}

	addDynamicObjPostRestCallPoste(domain, profile?): any {
		switch (domain) {
			case 'vehicles': {
				return this.getObjectScaffolding(
					'vehicles_detail',
					`/vehicle/detail-vehicle`
					// `/vehicle/detail-vehicle/${profile.plate}/${profile.contractId}`
				)
			}
			case 'contracts': {
				return this.getObjectScaffolding('contracts_detail', `/contracts/detail`)
			}
			case 'tools_and_services': {
				if (profile.isFuelCard) {
					return this.getObjectScaffolding(
						'history-refuel',
						`/tools-service/history-refuel`
					)
				}
			}
			case 'maintenance_and_appointments': {
				return this.getObjectScaffolding(
					'maintenances_list_pt',
					`/maintenance-appointments/maintenance`
				)
			}
			case 'management': {
				return this.getObjectScaffolding(
					'management_list',
					`/maintenance-appointments/maintenance-detail` //path nuovo component gestionale
				)
			}
		}
	}

	getObjectScaffolding(label, path): any {
		return {
			child: [],
			cod: label,
			id: 0,
			label,
			path,
		}
	}

	checkIfPlateAndContractExist(profile: Profile): void {
		if (!!!profile.plate && !!!profile.contractId) {
			this.snack.openSnackReferClassWithoutTranslate(
				this.i18n.getTranslation('plate_contract_no_exist'),
				SNACKBAR_CLASS.WARNING_CLASS
			)
		} else if (!!!profile.plate && !!profile.contractId) {
			this.snack.openSnackReferClassWithoutTranslate(
				this.i18n.getTranslation('plate_no_exist'),
				SNACKBAR_CLASS.WARNING_CLASS
			)
		} else if (!!profile.plate && !!!profile.contractId) {
			this.snack.openSnackReferClassWithoutTranslate(
				this.i18n.getTranslation('contract_no_exist'),
				SNACKBAR_CLASS.WARNING_CLASS
			)
		}
	}

	findTerm(basePath, term): any {
		if (basePath.includes(term)) {
			return basePath
		}
	}

	removeElementStartingFromTechName(arrInput, techname): any {
		if (!!arrInput) {
			const arr = arrInput
			const indexOfObject = arr.findIndex((object) => {
				return object.techname === techname
			})

			if (indexOfObject !== -1) {
				arr.splice(indexOfObject, 1)
			}
			return arr
		}
	}

	removeElementFromArray(arrInput, description): any {
		if (!!arrInput) {
			const arr = arrInput
			const indexOfObject = arr.findIndex((object) => {
				return object.description === description
			})

			if (indexOfObject !== -1) {
				arr.splice(indexOfObject, 1)
			}
			return arr
		}
	}

	removeElementFromArrayStartingFromCod(arrInput, cod): any {
		if (!!arrInput) {
			const arr = arrInput
			const indexOfObject = arr.findIndex((object) => {
				return object.cod === cod
			})

			if (indexOfObject !== -1) {
				arr.splice(indexOfObject, 1)
			}
			return arr
		}
	}

	getContactIdFromStore(): string {
		const contactStoreFromSTore = this.profileManagementService.getProfileByStore().contactId
		return contactStoreFromSTore
	}

	getConcatenatedCustomerIdsFromSession(): any {
		const customerIdsArray = this.getCustomerIdsFromSession()

		return customerIdsArray.join(',')
	}

	getConcatenatedCustomerRefsFromSession(): any {
		const customerRefsArray = this.getCustomerRefsFromSession()

		return customerRefsArray.join(',')
	}

	getCustomerIdsFromSession(): any {
		const profileCustomerId = JSON.parse(sessionStorage.getItem('profile'))?.customerId
		const hierarchyIds = this.hierarchyManagementService.getHierarchyIds()
		return !!hierarchyIds && hierarchyIds.length > 0
			? hierarchyIds //this.concatIdAndRemoveDuplicate(hierarchyIds, +profileCustomerId)
			: [profileCustomerId]
	}

	getCustomerRefsFromSession() {
		const profileCustomerRef = JSON.parse(sessionStorage.getItem('profile')).customerReference
		const hierarchyRefss = this.hierarchyManagementService.getHierarchyRefs()
		return !!hierarchyRefss && hierarchyRefss.length > 0
			? this.concatIdAndRemoveDuplicate(hierarchyRefss, +profileCustomerRef)
			: [profileCustomerRef]
	}

	getCustomerRefsFromSessionAppointments() {
		const profileCustomerRef = JSON.parse(sessionStorage.getItem('profile')).customerReference
		const hierarchyRefss = this.hierarchyManagementService.getHierarchyRefs()
		return !!hierarchyRefss && hierarchyRefss.length > 0
			? this.concatIdAndRemoveDuplicate(hierarchyRefss, profileCustomerRef)
			: [profileCustomerRef]
	}

	getContactId(): any {
		const contactId = JSON.parse(this.profileManagementService.getProfileByStore().contactId)
		return contactId
	}

	getContractId(): any {
		const contractId = JSON.parse(this.profileManagementService.getProfileByStore().contractId)
		return contractId
	}

	getCodePlateIfCurrentUserIsDriver(): string {
		const profile: Profile = this.profileManagementService.getProfileByStore()
		const rolesIds = [1, 3, 5, 6, 8, 9]
		return rolesIds.includes(+profile.role) ? profile.plate : ''
	}

	getContractIfCurrentUserIsDriver(): string {
		const profile: Profile = this.profileManagementService.getProfileByStore()
		const rolesIds = [1, 3, 5, 6, 8, 9]
		return rolesIds.includes(+profile.role) ? profile.contractId : ''
	}

	checkIfNotDriverOrRicaricar(): boolean {
		const profile: Profile = this.profileManagementService.getProfileByStore()
		const rolesIds = [2, 3, 6, 7, 8]
		return !rolesIds.includes(+profile.role)
	}

	concatIdAndRemoveDuplicate(hierarchyIds, profileCustomerId): any {
    if(hierarchyIds.length == 0){
      hierarchyIds.push(profileCustomerId)
    }
		hierarchyIds = this.deleteDuplicateFromHierarchySelection(hierarchyIds)
		return hierarchyIds
	}

	deleteDuplicateFromHierarchySelection(hierarchyIds): any {
		return hierarchyIds.filter((elem, index, self) => index === self.indexOf(elem))
	}

	getStringSearchValue(value: string): string {
		return value ? value : ''
	}

	getValuesFromArray(values: any[]): string {
		return values ? values.join(',') : ''
	}

	checkIfIsFm(): boolean {
		const profile = this.profileManagementService.getProfileByStore()
		return (
			profile.role == '2' ||
			profile.role == '7' ||
			profile.role == '10' ||
			profile.role == '11' ||
			profile.role == '400031'
		)
	}

	loadFavicon(): BRAND_FAVICON {
		const hostname = window.location.href
		switch (this.basePath) {
			case this.findTerm(this.basePath, 'fordfleetmanagement'):
				return BRAND_FAVICON.FFM
			case this.findTerm(this.basePath, 'ford'):
				return BRAND_FAVICON.FORD
			case this.findTerm(this.basePath, 'honda'):
				return BRAND_FAVICON.HONDA
			case this.findTerm(this.basePath, 'suzuki'):
				return BRAND_FAVICON.SUZUKI
			case this.findTerm(this.basePath, 'landrover'):
				return BRAND_FAVICON.LAND_ROVER
			case this.findTerm(this.basePath, 'jaguar'):
				return BRAND_FAVICON.JAGUAR
			case this.findTerm(this.basePath, 'lynkco'):
				return BRAND_FAVICON.LYNKCO
			case this.findTerm(this.basePath, 'smart'):
				return BRAND_FAVICON.SMART
			case this.findTerm(this.basePath, 'omodajaecoo'):
				return BRAND_FAVICON.OMODA_JAECOO
			case this.findTerm(this.basePath, 'mg'):
				return BRAND_FAVICON.MG
			case this.findTerm(this.basePath, 'fordfleetmanagement'):
				return BRAND_FAVICON.FFM
			default:
				return BRAND_FAVICON.AYVENS
		}
	}

	// true quando siamo su una captive di brand (che l'utente conosce come "My Area":
	// ford, suzuki, mg, ...), false sulla captive principale ALD / My Ayvens.
	isMyAreaCaptive(): boolean {
		switch (this.basePath) {
			case this.findTerm(this.basePath, 'fordfleetmanagement'):
			case this.findTerm(this.basePath, 'ford'):
			case this.findTerm(this.basePath, 'honda'):
			case this.findTerm(this.basePath, 'suzuki'):
			case this.findTerm(this.basePath, 'landrover'):
			case this.findTerm(this.basePath, 'jaguar'):
			case this.findTerm(this.basePath, 'lynkco'):
			case this.findTerm(this.basePath, 'smart'):
			case this.findTerm(this.basePath, 'omodajaecoo'):
			case this.findTerm(this.basePath, 'mg'):
				return true
			default:
				return false
		}
	}
}
